import { Box, Paper, Typography } from "@mui/material";
import ShowFavoritesButton from "../../../components/favorite/ShowFavoritesButton";
import { useGlobalMarketSpreadPriceContext } from "../../../context/global-market/GlobalMarketSpreadPriceContext";
import Favorites from "../../../components/favorite/Favorites";
import GlobalMarketSpreadPriceFavoriteCard from "./GlobalMarketSpreadPriceFavoriteCard";
import GlobalMarketSpreadPriceForm from "./GlobalMarketSpreadPriceForm";
import GlobalMarketSpreadPriceChart from "./GlobalMarketSpreadPriceChart";
import { deleteData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";

const GlobalMarketSpreadPrice = () => {
  const {
    isFavoritesModal,
    setIsFavoritesModal,
    favorites,
    handleShowChart,
    setInputValues1,
    setInputValues2,
    isLoadingChart,
  } = useGlobalMarketSpreadPriceContext();

  const handleSelectedFavorite = async (favorite) => {
    const {
      industry_1,
      commodity_type_1,
      commodity_1,
      transit_1,
      industry_2,
      commodity_type_2,
      commodity_2,
      transit_2,
      industry_1_name,
      commodity_type_1_name,
      commodity_1_name,
      transit_1_name,
      industry_2_name,
      commodity_type_2_name,
      commodity_2_name,
      transit_2_name,
    } = favorite;

    setInputValues1({
      industry: { id: industry_1, name: industry_1_name },
      commodityType: { id: commodity_type_1, name: commodity_type_1_name },
      commodity: commodity_1 && { id: commodity_1, name: commodity_1_name },
      transitType: transit_1 && { id: transit_1, name: transit_1_name },
    });

    setInputValues2({
      industry: { id: industry_2, name: industry_2_name },
      commodityType: { id: commodity_type_2, name: commodity_type_2_name },
      commodity: commodity_2 && { id: commodity_2, name: commodity_2_name },
      transitType: transit_2 && { id: transit_2, name: transit_2_name },
    });

    const body = {
      industry_1_id: industry_1,
      commodity_type_1_id: commodity_type_1,
      commodity_1_id: commodity_1,
      transit_1_id: transit_1,
      industry_2_id: industry_2,
      commodity_type_2_id: commodity_type_2,
      commodity_2_id: commodity_2,
      transit_2_id: transit_2,
    };

    await handleShowChart(body);
    setIsFavoritesModal(false);
  };

  const handleDeleteFavorite = async (id, e) => {
    e.stopPropagation();
    const res = await deleteData(`/favorite/global-favorite-ratio-chart/${id}`);
    if (res.status === 200)
      await mutate("/favorite/global-favorite-ratio-chart");
  };

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          اسپرد قیمتی کالا
        </Typography>
        <ShowFavoritesButton onClick={() => setIsFavoritesModal(true)} />
      </Box>

      <Favorites
        isChartLoading={isLoadingChart}
        isOpen={isFavoritesModal}
        handleClose={() => setIsFavoritesModal(false)}
        favorites={favorites}
        handleSelectedFavorite={handleSelectedFavorite}
        handleDeleteFavorite={handleDeleteFavorite}
        FavoriteCard={GlobalMarketSpreadPriceFavoriteCard}
      />
      <GlobalMarketSpreadPriceForm />
      <GlobalMarketSpreadPriceChart />
    </Paper>
  );
};

export default GlobalMarketSpreadPrice;
